import Api from '../api';
import {
  LIST_OPERATORS, LIST_OPERATORS_URL,
  CREATE_OPERATOR, CREATE_OPERATOR_URL,
  UPDATE_OPERATOR_MGR, UPDATE_OPERATOR_MGR_URL,
  STOP_OPERATOR, STOP_OPERATOR_URL,
  START_OPERATOR, START_OPERATOR_URL,
  RESTART_OPERATOR, RESTART_OPERATOR_URL,
  GET_KANNEL_STATUS, GET_KANNEL_STATUS_URL,
  LIST_OPERATOR_HEALTH, LIST_OPERATOR_HEALTH_URL,
  GET_ROUTE_CHAIN, GET_ROUTE_CHAIN_URL,
  SET_OPERATOR_ROUTE, SET_OPERATOR_ROUTE_URL,
  REMOVE_OPERATOR_ROUTE, REMOVE_OPERATOR_ROUTE_URL,
  GET_GLOBAL_ROUTING_CONFIG, GET_GLOBAL_ROUTING_CONFIG_URL,
  UPDATE_GLOBAL_ROUTE, UPDATE_GLOBAL_ROUTE_URL,
  ENABLE_FORCE_GLOBAL, ENABLE_FORCE_GLOBAL_URL,
  DISABLE_FORCE_GLOBAL, DISABLE_FORCE_GLOBAL_URL,
  LIST_TENANT_ROUTES, LIST_TENANT_ROUTES_URL,
  BULK_SET_OPERATOR_ROUTE, BULK_SET_OPERATOR_ROUTE_URL,
  LIST_KANNEL_BOXES, LIST_KANNEL_BOXES_URL,
  UPSERT_KANNEL_BOX, UPSERT_KANNEL_BOX_URL,
  LIST_BOX_OPERATORS, LIST_BOX_OPERATORS_URL,
  SET_BOX_OPERATORS, SET_BOX_OPERATORS_URL,
  LIST_BOX_SMSBOXES, LIST_BOX_SMSBOXES_URL,
  SET_BOX_SMSBOXES, SET_BOX_SMSBOXES_URL
} from '../lib/constant';
import {handleAPIDispatch} from '../lib/utils';

export function listOperators() {
  const request = Api.get(LIST_OPERATORS_URL);
  return handleAPIDispatch(request, LIST_OPERATORS);
}

export function createOperator(params) {
  const apiParams = {
    code: params.code,
    name: params.name,
    smsc_id: params.smscId,
    protocol: params.protocol || 'smpp',
    host: params.host,
    port: parseInt(params.port) || 2775,
    username: params.username || '',
    password: params.password || '',
    system_type: params.systemType || '',
    throughput: parseInt(params.throughput) || 0,
    max_pending: parseInt(params.maxPending) || 5000,
    instances: parseInt(params.instances, 10) || 1,
    country_code: params.countryCode || 'IN',
    is_active: params.isActive !== false,
    is_default: params.isDefault === true,
    dlt_tm_id: params.dltTmId || '',
    dlt_tm_mode: params.dltTmMode || 'chain',
    smpp_config: {
      interface_version: parseInt(params.interfaceVersion) || 34,
      transceiver_mode: params.transceiverMode !== false,
      source_addr_ton: parseInt(params.sourceAddrTon) || 0,
      source_addr_npi: parseInt(params.sourceAddrNpi) || 0,
      dest_addr_ton: parseInt(params.destAddrTon) || 0,
      dest_addr_npi: parseInt(params.destAddrNpi) || 0,
      reconnect_delay: parseInt(params.reconnectDelay) || 5,
      keepalive: parseInt(params.keepalive) || 60,
      enquire_link_interval: parseInt(params.enquireLinkInterval) || 30,
      wait_ack: parseInt(params.waitAck) || 10,
      wait_ack_expire: params.waitAckExpire || '0x00',
      dlt_entity_tag: params.dltEntityTag || '',
      dlt_template_tag: params.dltTemplateTag || '',
      dlt_tm_tag: params.dltTmTag || '',
      msg_id_type: params.msgIdType || ''
    }
  };
  const request = Api.post(CREATE_OPERATOR_URL, apiParams);
  return handleAPIDispatch(request, CREATE_OPERATOR);
}

export function updateOperator(operatorId, params) {
  const apiParams = {
    id: operatorId,
    name: params.name,
    host: params.host,
    port: parseInt(params.port) || 2775,
    username: params.username || '',
    password: params.password || '',
    throughput: parseInt(params.throughput) || 0,
    max_pending: parseInt(params.maxPending) || 5000,
    instances: parseInt(params.instances, 10) || 1,
    is_active: params.isActive !== false,
    smpp_config: {
      interface_version: parseInt(params.interfaceVersion) || 34,
      transceiver_mode: params.transceiverMode !== false,
      source_addr_ton: parseInt(params.sourceAddrTon) || 0,
      source_addr_npi: parseInt(params.sourceAddrNpi) || 0,
      dest_addr_ton: parseInt(params.destAddrTon) || 0,
      dest_addr_npi: parseInt(params.destAddrNpi) || 0,
      reconnect_delay: parseInt(params.reconnectDelay) || 5,
      keepalive: parseInt(params.keepalive) || 60,
      enquire_link_interval: parseInt(params.enquireLinkInterval) || 30,
      wait_ack: parseInt(params.waitAck) || 10,
      wait_ack_expire: params.waitAckExpire || '0x00',
      dlt_entity_tag: params.dltEntityTag || '',
      dlt_template_tag: params.dltTemplateTag || '',
      dlt_tm_tag: params.dltTmTag || '',
      msg_id_type: params.msgIdType || ''
    },
    dlt_tm_id: params.dltTmId || '',
    dlt_tm_mode: params.dltTmMode || 'chain'
  };
  const request = Api.put(UPDATE_OPERATOR_MGR_URL.replace('{operatorId}', operatorId), apiParams);
  return handleAPIDispatch(request, UPDATE_OPERATOR_MGR);
}

export function stopOperator(smscId) {
  const request = Api.post(STOP_OPERATOR_URL.replace('{smscId}', smscId), {smsc_id: smscId});
  return handleAPIDispatch(request, STOP_OPERATOR);
}

export function startOperator(smscId) {
  const request = Api.post(START_OPERATOR_URL.replace('{smscId}', smscId), {smsc_id: smscId});
  return handleAPIDispatch(request, START_OPERATOR);
}

export function restartOperator(smscId) {
  const request = Api.post(RESTART_OPERATOR_URL.replace('{smscId}', smscId), {smsc_id: smscId});
  return handleAPIDispatch(request, RESTART_OPERATOR);
}

export function getKannelStatus() {
  const request = Api.get(GET_KANNEL_STATUS_URL);
  return handleAPIDispatch(request, GET_KANNEL_STATUS);
}

export function listOperatorHealth() {
  const request = Api.get(LIST_OPERATOR_HEALTH_URL);
  return handleAPIDispatch(request, LIST_OPERATOR_HEALTH);
}

export function getRouteChain(tenantId, productCode, messageType) {
  let url = GET_ROUTE_CHAIN_URL;
  const params = [];
  if (tenantId) params.push(`tenant_id=${tenantId}`);
  if (productCode) params.push(`product_code=${productCode}`);
  if (messageType) params.push(`message_type=${messageType}`);
  if (params.length) url += '?' + params.join('&');
  const request = Api.get(url);
  return handleAPIDispatch(request, GET_ROUTE_CHAIN);
}

export function setOperatorRoute(params) {
  const apiParams = {
    tenant_id: params.tenantId || '',
    product_code: params.productCode || 'sms',
    operator_id: params.operatorId,
    message_type: params.messageType || 'transactional',
    priority: parseInt(params.priority) || 1,
    weight: parseInt(params.weight) || 100
  };
  const request = Api.post(SET_OPERATOR_ROUTE_URL, apiParams);
  return handleAPIDispatch(request, SET_OPERATOR_ROUTE);
}

export function removeOperatorRoute(routeId) {
  const request = Api.delete(REMOVE_OPERATOR_ROUTE_URL.replace('{routeId}', routeId));
  return handleAPIDispatch(request, REMOVE_OPERATOR_ROUTE);
}

export function getGlobalRoutingConfig() {
  const request = Api.get(GET_GLOBAL_ROUTING_CONFIG_URL);
  return handleAPIDispatch(request, GET_GLOBAL_ROUTING_CONFIG);
}

export function updateGlobalRoute(smscId, messageType) {
  const request = Api.put(UPDATE_GLOBAL_ROUTE_URL, {smsc_id: smscId, message_type: messageType || 'transactional'});
  return handleAPIDispatch(request, UPDATE_GLOBAL_ROUTE);
}

export function enableForceGlobal(messageType, smscId) {
  const request = Api.post(ENABLE_FORCE_GLOBAL_URL, {message_type: messageType, smsc_id: smscId});
  return handleAPIDispatch(request, ENABLE_FORCE_GLOBAL);
}

export function disableForceGlobal(messageType) {
  const request = Api.post(DISABLE_FORCE_GLOBAL_URL, {message_type: messageType});
  return handleAPIDispatch(request, DISABLE_FORCE_GLOBAL);
}

export function listTenantRoutes(search = '', page = 1, pageSize = 50) {
  const params = [`page=${page}`, `page_size=${pageSize}`];
  if (search) params.push(`search=${encodeURIComponent(search)}`);
  const request = Api.get(LIST_TENANT_ROUTES_URL + '?' + params.join('&'));
  return handleAPIDispatch(request, LIST_TENANT_ROUTES);
}

export function bulkSetOperatorRoute(params) {
  const apiParams = {
    operator_id: params.operatorId,
    product_code: params.productCode || 'sms',
    message_type: params.messageType || 'transactional',
    exclude_tenant_ids: params.excludeTenantIds || [],
    priority: parseInt(params.priority) || 1,
    weight: parseInt(params.weight) || 100
  };
  const request = Api.post(BULK_SET_OPERATOR_ROUTE_URL, apiParams);
  return handleAPIDispatch(request, BULK_SET_OPERATOR_ROUTE);
}

export function listKannelBoxes() {
  const request = Api.get(LIST_KANNEL_BOXES_URL);
  return handleAPIDispatch(request, LIST_KANNEL_BOXES);
}

export function upsertKannelBox(boxId, params) {
  const apiParams = {
    box_id: boxId,
    display_name: params.displayName || boxId,
    smsbox_max_pending: parseInt(params.smsboxMaxPending) || 50000,
    log_level: parseInt(params.logLevel) >= 0 ? parseInt(params.logLevel) : 1
  };
  const request = Api.put(UPSERT_KANNEL_BOX_URL.replace('{boxId}', boxId), apiParams);
  return handleAPIDispatch(request, UPSERT_KANNEL_BOX);
}

export function listBoxOperators(boxId) {
  const request = Api.get(LIST_BOX_OPERATORS_URL.replace('{boxId}', boxId));
  return handleAPIDispatch(request, LIST_BOX_OPERATORS);
}

export function setBoxOperators(boxId, operatorIds) {
  const apiParams = { box_id: boxId, operator_ids: operatorIds || [] };
  const request = Api.put(SET_BOX_OPERATORS_URL.replace('{boxId}', boxId), apiParams);
  return handleAPIDispatch(request, SET_BOX_OPERATORS);
}

export function listBoxSmsboxes(boxId) {
  const request = Api.get(LIST_BOX_SMSBOXES_URL.replace('{boxId}', boxId));
  return handleAPIDispatch(request, LIST_BOX_SMSBOXES);
}

export function setBoxSmsboxes(boxId, smsboxIds) {
  const apiParams = { box_id: boxId, smsbox_ids: smsboxIds || [] };
  const request = Api.put(SET_BOX_SMSBOXES_URL.replace('{boxId}', boxId), apiParams);
  return handleAPIDispatch(request, SET_BOX_SMSBOXES);
}
